import BenchlingConfig from 'BenchlingConfig';

/**
 * Check if content workers are enabled.
 * @param timedOut a flag indicating whether or not we've seen a previous timeout
 * @returns true if content workers are enabled, false otherwise
 */
export default function enabled(timedOut: boolean): boolean {
  return (
    !timedOut &&
    BenchlingConfig.ELN_ENABLE_CONTENT_WORKERS &&
    Math.random() < BenchlingConfig.ELN_ENABLE_CONTENT_WORKERS_PROBABILITY
  );
}
